import { render, staticRenderFns } from "./NotificationBatches.vue?vue&type=template&id=5e35ce8d&"
import script from "./NotificationBatches.vue?vue&type=script&lang=js&"
export * from "./NotificationBatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports